module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component"
  }, [_c('div', {
    staticClass: " form-wrap"
  }, [_c('div', {
    staticClass: "form-list py-3"
  }, [_c('div', {
    staticClass: "row order-history-area"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e58286e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/partials/MyPage/Order/Download/PageContent.vue
// module id = 676
// module chunks = 0